import { Component, Input } from '@angular/core';

const RADIUS = 45;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

@Component({
  selector: 'app-ring-progress',
  imports: [],
  templateUrl: './ring-progress.component.html',
  styleUrl: './ring-progress.component.scss'
})
export class RingProgressComponent {
  @Input() percent = 0;
  @Input() centerValue = '';
  @Input() centerLabel = 'Completed';
  @Input() size = 96;

  get circumference(): number {
    return CIRCUMFERENCE;
  }

  get dashOffset(): number {
    return CIRCUMFERENCE - (CIRCUMFERENCE * this.percent) / 100;
  }

  get displayValue(): string {
    return this.centerValue || `${this.percent}%`;
  }
}
